import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { mapStateToProps, mapDispatchToProps } from 'entries/containers/image_name_tile';
import NameDenseItem from 'entries/components/name_dense_item';

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NameDenseItem));



// WEBPACK FOOTER //
// ./entries/containers/name_dense_item.js